export default __webpack_public_path__ + "assets/images/jackpot_desktop.9e64b9.png";